export const centerContentClass = `d-flex align-items-center justify-content-center`
export const navbarStyles = {
  btn: `btn btn btn-outline-light btn-sm mx-2`,
  headerClass: `pt-2 d-print-none d-flex justify-content-center align-items-center`,
  link: `font-weight-bold text-light mx-2`,
}
